import _ from "lodash";
import React from "react";
import { colors } from "Constants";
import { AddAssessment, AddNote, TagElements } from "SvgComponents";
import { getIconList } from "GenericTableEditor/IconPicker/IconPickerUtils";

const iconListForPicker = getIconList();

import {
  LoudspeakerOutlined,
  AtlOutlined,
  PageFoldPortraitOutlined,
  SqauresCircleOutlined,
  GoalsOutlined,
  UserReflectionOutlined,
  AssessmentApplicableOutlined,
  CommentQuestionMarkOutlined,
  PuzzleCircleOutlined,
  HeadOutlined,
  ListNumberedOutlined,
  SquareCircleOutlined,
  FileNotFoundOutlined,
  SpiralBookStarOutlined,
  ClipboardPencilLinesOutlined,
  HierarchyOutlined,
  StructureOutlined,
  AssessmentOutlined,
  PuzzlePiecesOutlined,
  PageBookmarkOutlined,
  AssessmentandEvaluationOutlined,
  PuzzlePieceOutlined,
  GridOutlined,
  ChecklistOutlined,
  HeadLeafOutlined,
  ResourceOutlined,
  ClassProgressOutlined,
  MultipleUsersOutlined,
  GlobeOutlined,
  SpiralBookLinesOutlined,
  HandOutlined,
  HeartLikeOutlined,
  AssessmentEvaluatedOutlined,
} from "@toddle-edu/ds-icons";
import { Avatar } from "@toddle-edu/ds-web";

const PlannerIcon = ({ icon, color }) => {
  return (
    <Avatar
      icon={icon}
      size="medium"
      shape="square"
      theme="light"
      color={color}
      iconType="icon"
      dsVersion="2.0"
    />
  );
};

export const defaultPlannerIcons = {
  PicnActions: <PlannerIcon icon={<LoudspeakerOutlined />} color="blue" />,
  PicnATL: <PlannerIcon icon={<AtlOutlined />} color="blue" />,
  PicnKeyConcepts: (
    <PlannerIcon icon={<PuzzleCircleOutlined />} color="yellow" />
  ),
  PicnRelatedConcepts: (
    <PlannerIcon icon={<SquareCircleOutlined />} color="blue" />
  ),
  PicnLOI: <PlannerIcon icon={<LoudspeakerOutlined />} color="blue" />,
  PicnLP: <PlannerIcon icon={<HeadOutlined />} color="pink" />,
  PicnObjectives: <PlannerIcon icon={<GoalsOutlined />} color="violet" />,
  PicnTheme: <PlannerIcon icon={<GridOutlined />} color="pink" />,
  PicnPriorLearning: (
    <PlannerIcon icon={<ChecklistOutlined />} color="yellow" />
  ),
  PicnTQues: (
    <PlannerIcon icon={<CommentQuestionMarkOutlined />} color="blue" />
  ),
  PicnLearningGoals: <PlannerIcon icon={<GoalsOutlined />} color="pink" />,
  PicnCentralIdea: (
    <PlannerIcon icon={<PuzzlePiecesOutlined />} color="yellow" />
  ),
  PicnConnections: <PlannerIcon icon={<StructureOutlined />} color="pink" />,
  PicnInReflections: (
    <PlannerIcon icon={<UserReflectionOutlined />} color="yellow" />
  ),
  PicnLE: <PlannerIcon icon={<HeadLeafOutlined />} color="yellow" />,
  PicnOnAssmnts: (
    <PlannerIcon icon={<AssessmentandEvaluationOutlined />} color="blue" />
  ),
  PicnResources: <PlannerIcon icon={<ResourceOutlined />} color="blue" />,
  PicnOnReflections: (
    <PlannerIcon icon={<UserReflectionOutlined />} color="pink" />
  ),
  PicnSelfAssmnt: <PlannerIcon icon={<ClassProgressOutlined />} color="blue" />,
  PicnStudentAgency: (
    <PlannerIcon icon={<MultipleUsersOutlined />} color="yellow" />
  ),
  AddAssessment: (
    <AddAssessment width={32} height={32} fill={colors.neutral400} />
  ),
  AddNote: <AddNote width={32} height={32} fill={colors.neutral400} />,
  TagElements: <TagElements width={32} height={32} fill={colors.neutral400} />,

  PicnATLV2: <PlannerIcon icon={<AtlOutlined />} color="pink" />,
  PicnContent: <PlannerIcon icon={<PageFoldPortraitOutlined />} color="blue" />,
  PicnDifferentiations: (
    <PlannerIcon icon={<SqauresCircleOutlined />} color="violet" />
  ),
  PicnFormative: (
    <PlannerIcon icon={<AssessmentApplicableOutlined />} color="yellow" />
  ),
  PicnGlobalContext: <PlannerIcon icon={<GlobeOutlined />} color="yellow" />,
  PicnInquiryQues: (
    <PlannerIcon icon={<CommentQuestionMarkOutlined />} color="yellow" />
  ),
  PicnKeyConceptsV2: (
    <PlannerIcon icon={<PuzzleCircleOutlined />} color="violet" />
  ),
  PicnLPA: <PlannerIcon icon={<HeadOutlined />} color="violet" />,
  PicnLearningStandards: (
    <PlannerIcon icon={<ListNumberedOutlined />} color="blue" />
  ),
  PicnObjective: <PlannerIcon icon={<GoalsOutlined />} color="violet" />,
  PicnPriorReflection: (
    <PlannerIcon icon={<UserReflectionOutlined />} color="pink" />
  ),
  PicnRelatedConceptsV2: (
    <PlannerIcon icon={<SquareCircleOutlined />} color="yellow" />
  ),
  PicnStatementOfInquiry: (
    <PlannerIcon icon={<FileNotFoundOutlined />} color="blue" />
  ),
  PicnSubjectFocus: (
    <PlannerIcon icon={<SpiralBookStarOutlined />} color="pink" />
  ),
  PicnSummative: (
    <PlannerIcon icon={<ClipboardPencilLinesOutlined />} color="yellow" />
  ),

  PicnInterdisCriteria: (
    <PlannerIcon icon={<HierarchyOutlined />} color="blue" />
  ),
  PicnInterLearnExpTeachStrat: (
    <PlannerIcon icon={<StructureOutlined />} color="yellow" />
  ),
  PicnLearnExpTeachStrat: (
    <PlannerIcon icon={<AssessmentOutlined />} color="pink" />
  ),
  PicnPurposeIntegration: (
    <PlannerIcon icon={<PuzzlePiecesOutlined />} color="blue" />
  ),
  PicnDuringReflection: (
    <PlannerIcon icon={<UserReflectionOutlined />} color="violet" />
  ),
  PicnDisciplinarySubGeneric: (
    <PlannerIcon icon={<PageBookmarkOutlined />} color="yellow" />
  ),
  PicnAssessments: (
    <PlannerIcon icon={<AssessmentandEvaluationOutlined />} color="yellow" />
  ),
  PicnFormsIntegration: (
    <PlannerIcon icon={<PuzzlePieceOutlined />} color="pink" />
  ),
  PicnLEV2: <PlannerIcon icon={<AssessmentOutlined />} color="pink" />,
  PicnAfterReflection: (
    <PlannerIcon icon={<UserReflectionOutlined />} color="blue" />
  ),
  ObjectivesBlueDuotone: <PlannerIcon icon={<GoalsOutlined />} color="blue" />,
  ReflectionPriorToTeachingDuotone: (
    <PlannerIcon icon={<UserReflectionOutlined />} color="pink" />
  ),
  ReflectionAfterTeachingDuotone: (
    <PlannerIcon icon={<UserReflectionOutlined />} color="blue" />
  ),
  LeAndTeachingStrategiesDuotonePink: (
    <PlannerIcon icon={<AssessmentOutlined />} color="pink" />
  ),
  ObjectivesDuotoneViolet: (
    <PlannerIcon icon={<GoalsOutlined />} color="violet" />
  ),
  PicnUnitDetails: (
    <PlannerIcon icon={<SpiralBookLinesOutlined />} color="yellow" />
  ),
  LearnerProfileDuotoneGreen: (
    <PlannerIcon icon={<HeadOutlined />} color="teal" />
  ),
  HandDuotonePink: <PlannerIcon icon={<HandOutlined />} color="pink" />,
  HeartDuotoneBlue: <PlannerIcon icon={<HeartLikeOutlined />} color="blue" />,
  JournalDuotone: (
    <PlannerIcon icon={<SpiralBookLinesOutlined />} color="blue" />
  ),
  PreliminaryReviewDuotone: (
    <PlannerIcon icon={<AssessmentEvaluatedOutlined />} color="blue" />
  ),
};

export const plannerIcons = ({ icon }) => {
  if (_.has(defaultPlannerIcons, icon)) return defaultPlannerIcons[icon];
  return _.get(iconListForPicker, `${icon}.component`, null);
};
